// extracted by mini-css-extract-plugin
export default {"bnWrapper":"BottomNav_bnWrapper__OjFDv","bnItem":"BottomNav_bnItem__XfIXR","bnItemOn":"BottomNav_bnItemOn__0NiNo","bnItemOff":"BottomNav_bnItemOff__gihxc"};